/* import __COLOCATED_TEMPLATE__ from './datetime-inline-edit.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import dayjs from 'dayjs';

export default class DatetimeInlineEditComponent extends Component {
	@tracked isEditing = false;
	@tracked valueForEdit = '';

	@action
	startEditing() {
		// Convert the model value to datetime-local format
		const value = this.args.model[this.args.field];
		if (value) {
			this.valueForEdit = dayjs(value).format('YYYY-MM-DDTHH:mm:ss');
		} else {
			this.valueForEdit = '';
		}
		this.isEditing = true;
	}

	@action
	updateValue(event) {
		this.valueForEdit = event.target.value;
	}

	@action
	save() {
		if (this.valueForEdit) {
			// Convert datetime-local format to timestamp
			const timestamp = dayjs(this.valueForEdit).valueOf();
			this.args.model[this.args.field] = timestamp;
		} else {
			this.args.model[this.args.field] = null;
		}
		this.args.model.save();
		this.isEditing = false;
	}

	@action
	cancel() {
		this.isEditing = false;
	}

	@action
	handleKeyDown(event) {
		if (event.key === 'Enter' || event.keyCode === 13) {
			event.preventDefault();
			this.save();
		}
		if (event.key === 'Escape' || event.keyCode === 27) {
			this.cancel();
		}
	}

	@action
	handleSubmit(event) {
		event.preventDefault();
		this.save();
	}
}
